// ===== CHAT INTERNO =====
// ══ CHAT INTERNO v216 ══
const CHAT_CANAIS_CFG=[
  {id:'geral',nome:'Geral',icon:'ti-message-circle',desc:'Comunicação geral'},
  {id:'comercial',nome:'Comercial',icon:'ti-chart-bar',desc:'Vendas e orçamentos'},
  {id:'producao',nome:'Produção',icon:'ti-tools',desc:'Piso de fábrica e máquinas'},
  {id:'instalacao',nome:'Instalação',icon:'ti-hammer',desc:'Equipes externas e obras'},
  {id:'medicao',nome:'Medição',icon:'ti-ruler',desc:'Visitas e conferências técnicas'},
  {id:'materiais',nome:'Materiais',icon:'ti-package',desc:'Chapas, estoque e compras'},
  {id:'naoconformidades',nome:'Não conformidades',icon:'ti-alert-triangle',desc:'Ocorrências e qualidade'},
  {id:'administrativo',nome:'Administrativo',icon:'ti-building',desc:'Gestão e RH'},
  {id:'financeiro',nome:'Financeiro',icon:'ti-currency-real',desc:'Acesso restrito',restrito:true},
];
let _chatCanal='geral',_chatReplyTo=null,_chatVinculo=null,_chatInfoOpen=false,_chatEnviarComoDemanda=false,_chatEditandoId=null;

function initChatPage(){
  _renderChatSidebar();
  _selecionarCanalChat(_chatCanal);
  const msgsEl=document.getElementById('chat-msgs');if(msgsEl)msgsEl.onclick=_chatMsgsClickHandler;
}
// Delegação de clique em #chat-msgs: os dados da mensagem (id, vínculo) vêm de
// message.id/vinculo gravados no Firestore por qualquer membro com escrita em
// chat_mensagens, sem allowlist de caracteres na regra — nunca viraram string
// interpolada dentro de onclick="..." (escapeHtml() protege contra quebra de
// atributo HTML, mas não contra quebra da string JS dentro do próprio
// handler inline, já que o navegador decodifica entidades HTML antes de
// compilar o onclick como código). Os valores chegam só via dataset, nunca
// compilados como JS.
function _chatMsgsClickHandler(ev){
  const t=ev.target.closest('[data-chat-action]');if(!t)return;
  const action=t.dataset.chatAction,msgId=t.dataset.msgId;
  if(action==='responder')_chatResponder(msgId);
  else if(action==='editar')_chatEditar(msgId);
  else if(action==='excluir')_chatExcluir(msgId);
  else if(action==='vincular')_abrirVinculoMensagem(msgId);
  else if(action==='tarefa')_chatMsgParaTarefa(msgId);
  else if(action==='assumir-demanda')assumirDemanda(msgId);
  else if(action==='resolver-demanda')resolverDemanda(msgId);
  else if(action==='abrir-vinculo')_abrirVinculoRegistro(t.dataset.vincTipo,t.dataset.vincId);
}

function _renderChatSidebar(){
  _renderChatChannels();
  _renderChatDMs();
}

function _chatFilter(q){
  // simple filter: show/hide buttons by text match
  document.querySelectorAll('#chat-channels .chat-ch-btn,#chat-dms .chat-ch-btn').forEach(btn=>{
    btn.style.display=q&&!btn.textContent.toLowerCase().includes(q.toLowerCase())?'none':'';
  });
}

function _renderChatChannels(){
  const el=document.getElementById('chat-channels');if(!el)return;
  const msgs=CACHE.chat_mensagens||[];
  const curEmail=(window.SaaS?.currentUser?.()||{}).email||'';
  el.innerHTML=CHAT_CANAIS_CFG.map(ch=>{
    const naoLidas=msgs.filter(m=>m.canal===ch.id&&!m.excluido&&m.tipo!=='demanda'&&m.userEmail!==curEmail&&!(m.lido||{})[curEmail]).length;
    const demAberta=msgs.filter(m=>m.canal===ch.id&&m.tipo==='demanda'&&m.status==='aberta').length;
    const ultima=msgs.filter(m=>m.canal===ch.id&&!m.excluido).sort((a,b)=>(b.ts||'').localeCompare(a.ts||''))[0];
    const preview=ultima?escapeHtml((ultima.texto||'').slice(0,32))+(ultima.texto?.length>32?'…':''):'';
    const ativo=_chatCanal===ch.id;
    const badge=naoLidas||demAberta;
    return `<button class="chat-ch-btn${ativo?' active':''}" onclick="_selecionarCanalChat('${ch.id}')">
      <i class="ti ${ch.icon} chat-ch-icon"></i>
      <div class="chat-ch-body">
        <div class="chat-ch-row">
          <span class="chat-ch-nome">${escapeHtml(ch.nome)}${ch.restrito?'<i class="ti ti-lock" style="font-size:9px;margin-left:3px;opacity:.4"></i>':''}</span>
          ${badge?`<span class="chat-badge">${badge}</span>`:''}
        </div>
        ${preview?`<div class="chat-ch-preview">${preview}</div>`:''}
      </div>
    </button>`;
  }).join('');
}

function _renderChatDMs(){
  const el=document.getElementById('chat-dms');if(!el)return;
  const msgs=CACHE.chat_mensagens||[];
  const curEmail=(window.SaaS?.currentUser?.()||{}).email||'';
  const dmKeys=[...new Set(msgs.filter(m=>m.dm&&m.canal).map(m=>m.canal))];
  const meusDMs=dmKeys.filter(k=>!curEmail||k.includes(curEmail));
  if(!meusDMs.length){el.innerHTML='<div style="padding:3px 14px;font-size:11px;color:var(--muted)">Sem conversas</div>';return;}
  const equipe=CACHE.pessoas||[];
  el.innerHTML=meusDMs.map(k=>{
    const parts=k.replace('dm:','').split(':');
    const outraEmail=parts.find(e=>e!==curEmail)||parts[0];
    const outra=equipe.find(p=>p.email===outraEmail);
    const nome=outra?outra.nome:outraEmail.split('@')[0]||'Usuário';
    const naoLidas=msgs.filter(m=>m.canal===k&&m.userEmail!==curEmail&&!(m.lido||{})[curEmail]).length;
    const ativo=_chatCanal===k;
    return `<button class="chat-ch-btn${ativo?' active':''}" onclick="_selecionarCanalChat('${k}')">
      <div style="width:28px;height:28px;border-radius:50%;background:var(--accent);display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700;color:#fff;flex-shrink:0">${escapeHtml(nome.charAt(0).toUpperCase())}</div>
      <div class="chat-ch-body">
        <div class="chat-ch-row"><span class="chat-ch-nome">${escapeHtml(nome)}</span>${naoLidas?`<span class="chat-badge">${naoLidas}</span>`:''}</div>
      </div>
    </button>`;
  }).join('');
}

function _selecionarCanalChat(canal){
  _chatCanal=canal;_chatReplyTo=null;_chatVinculo=null;_chatEnviarComoDemanda=false;_chatEditandoId=null;
  const isDM=canal.startsWith('dm:');
  const curEmail=(window.SaaS?.currentUser?.()||{}).email||'';
  let nomeCanal='—',descCanal='';
  if(isDM){
    const outraEmail=canal.replace('dm:','').split(':').find(e=>e!==curEmail)||'';
    const outra=(CACHE.pessoas||[]).find(p=>p.email===outraEmail);
    nomeCanal='@ '+(outra?.nome||outraEmail.split('@')[0]||outraEmail);
    descCanal='Mensagem direta';
  } else {
    const ch=CHAT_CANAIS_CFG.find(c=>c.id===canal)||{nome:canal,desc:''};
    nomeCanal='# '+ch.nome;descCanal=ch.desc||'';
  }
  document.getElementById('chat-canal-nome').textContent=nomeCanal;
  document.getElementById('chat-canal-sub').textContent=descCanal;
  document.getElementById('chat-destino-label').textContent=nomeCanal;
  // Reset UI
  const rBar=document.getElementById('chat-reply-bar');if(rBar)rBar.style.display='none';
  const vBar=document.getElementById('chat-vinculo-bar');if(vBar)vBar.style.display='none';
  const tBadge=document.getElementById('chat-tipo-badge');if(tBadge)tBadge.style.display='none';
  const daBtn=document.getElementById('chat-demanda-toggle-btn');if(daBtn)daBtn.style.background='';
  const daSel=document.getElementById('chat-demanda-area');if(daSel)daSel.style.display='none';
  // Update info panel
  _renderChatInfo();
  // Mark read
  _marcarCanalLido(canal);
  _renderChatSidebar();
  _renderChatMessages();
}

async function _marcarCanalLido(canal){
  const curEmail=(window.SaaS?.currentUser?.()||{}).email||'';if(!curEmail)return;
  const lista=[...(CACHE.chat_mensagens||[])];
  let changed=false;
  lista.forEach(m=>{if(m.canal===canal&&m.userEmail!==curEmail&&!(m.lido||{})[curEmail]){m.lido={...(m.lido||{}),[curEmail]:true};changed=true;}});
  if(changed)await DB.set('chat_mensagens',lista);
}

function _renderChatMessages(){
  const el=document.getElementById('chat-msgs');if(!el)return;
  const msgs=(CACHE.chat_mensagens||[]).filter(m=>m.canal===_chatCanal&&!m.excluido).sort((a,b)=>(a.ts||'').localeCompare(b.ts||''));
  if(!msgs.length){
    el.innerHTML=`<div style="flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:10px;padding:40px 20px;color:var(--muted)">
      <i class="ti ti-messages" style="font-size:36px;opacity:.2"></i>
      <div style="text-align:center"><div style="font-weight:700;font-size:13px;color:var(--text);margin-bottom:3px">Nenhuma mensagem ainda</div>
      <div style="font-size:11px">Seja o primeiro a enviar algo neste canal.</div></div>
    </div>`;return;
  }
  const curEmail=(window.SaaS?.currentUser?.()||{}).email||'';
  let html='',ultimaData='';
  msgs.forEach(m=>{
    const minha=m.userEmail&&m.userEmail===curEmail;
    const hora=m.ts?new Date(m.ts).toLocaleTimeString('pt-BR',{hour:'2-digit',minute:'2-digit'}):'';
    const dataMsg=m.ts?new Date(m.ts).toLocaleDateString('pt-BR',{weekday:'short',day:'2-digit',month:'short',year:'numeric'}):'';
    if(dataMsg&&dataMsg!==ultimaData){
      html+=`<div style="display:flex;align-items:center;gap:8px;margin:12px 0 8px"><div style="flex:1;height:1px;background:var(--border)"></div><span style="font-size:10px;color:var(--muted);font-weight:600;text-transform:uppercase;white-space:nowrap">${dataMsg}</span><div style="flex:1;height:1px;background:var(--border)"></div></div>`;
      ultimaData=dataMsg;
    }
    // Demanda card
    if(m.tipo==='demanda'){
      const stCol=m.status==='resolvida'?'var(--green)':m.status==='assumida'?'var(--warn)':'var(--red)';
      const stTxt=m.status==='resolvida'?`Resolvida — ${escapeHtml(m.resolvidaPor||'')}`:m.status==='assumida'?`Assumida — ${escapeHtml(m.assumidaPor||'')}`:'Aguardando';
      html+=`<div class="chat-demanda-card" style="border-left:3px solid ${stCol}">
        <div style="display:flex;justify-content:space-between;align-items:flex-start;gap:8px;margin-bottom:4px">
          <div><span style="font-size:9px;font-weight:700;text-transform:uppercase;letter-spacing:.06em;background:${stCol};color:#fff;padding:1px 6px;border-radius:99px">DEMANDA</span><span style="font-size:10px;color:var(--muted);margin-left:6px">→ ${escapeHtml(m.area||'geral')}</span></div>
          <span style="font-size:10px;color:var(--muted)">${escapeHtml(m.user||'?')} · ${hora}</span>
        </div>
        <div style="font-size:13px;margin:6px 0;color:var(--text);white-space:pre-wrap;word-break:break-word">${escapeHtml(m.texto||'')}</div>
        ${m.vinculo?`<div style="font-size:10px;color:var(--accent);cursor:pointer;margin-bottom:6px" data-chat-action="abrir-vinculo" data-vinc-tipo="${escapeHtml(m.vinculo.tipo||'')}" data-vinc-id="${escapeHtml(m.vinculo.id||'')}"><i class="ti ti-link"></i> ${escapeHtml(m.vinculo.label||'')}</div>`:''}
        <div style="display:flex;justify-content:space-between;align-items:center">
          <span style="font-size:11px;font-weight:700;color:${stCol}">${stTxt}</span>
          <div style="display:flex;gap:5px">
            ${m.status!=='assumida'&&m.status!=='resolvida'?`<button class="btn btn-ghost btn-sm" style="font-size:11px;padding:2px 8px" data-chat-action="assumir-demanda" data-msg-id="${escapeHtml(m.id)}">Assumir</button>`:''}
            ${m.status!=='resolvida'?`<button class="btn btn-primary btn-sm" style="font-size:11px;padding:2px 8px" data-chat-action="resolver-demanda" data-msg-id="${escapeHtml(m.id)}">Resolver</button>`:''}
          </div>
        </div>
      </div>`;
      return;
    }
    // Reply reference
    let replyHtml='';
    if(m.replyTo){const orig=msgs.find(x=>x.id===m.replyTo);if(orig)replyHtml=`<div style="border-left:2px solid var(--accent);padding:2px 7px;margin-bottom:4px;font-size:11px;color:var(--muted);background:var(--surface);border-radius:0 4px 4px 0;opacity:.8"><strong>${escapeHtml(orig.user||'?')}:</strong> ${escapeHtml((orig.texto||'').slice(0,60))}${(orig.texto||'').length>60?'…':''}</div>`;}
    // Vinculo
    const vinculoHtml=m.vinculo?`<div style="font-size:10px;margin-top:4px;color:${minha?'rgba(255,255,255,.75)':'var(--accent)'};cursor:pointer" data-chat-action="abrir-vinculo" data-vinc-tipo="${escapeHtml(m.vinculo.tipo||'')}" data-vinc-id="${escapeHtml(m.vinculo.id||'')}"><i class="ti ti-link"></i> ${escapeHtml(m.vinculo.label||'')}</div>`:'';
    const tarefaHtml=m.tarefaId?`<div style="font-size:10px;margin-top:3px;color:${minha?'rgba(255,255,255,.7)':'var(--green)'}"><i class="ti ti-checkbox"></i> Convertida em tarefa</div>`:'';
    html+=`<div class="chat-msg-wrap${minha?' mine':''}" data-id="${escapeHtml(m.id)}">
      ${!minha?`<div class="chat-avatar">${escapeHtml((m.user||'?').charAt(0).toUpperCase())}</div>`:''}
      <div class="chat-msg-body">
        <div class="chat-msg-meta" style="${minha?'text-align:right':''}">${!minha?`<strong>${escapeHtml(m.user||'?')}</strong> · `:''}${hora}${m.editado?' · <em style="opacity:.55;font-style:italic;font-size:10px">editado</em>':''}</div>
        ${replyHtml}
        <div class="chat-bubble${minha?' mine':''}">${escapeHtml(m.texto||'')}${vinculoHtml}${tarefaHtml}</div>
        <div class="chat-msg-actions">
          <button class="chat-action-btn" title="Responder" data-chat-action="responder" data-msg-id="${escapeHtml(m.id)}"><i class="ti ti-arrow-back-up"></i></button>
          ${minha?`<button class="chat-action-btn" title="Editar" data-chat-action="editar" data-msg-id="${escapeHtml(m.id)}"><i class="ti ti-pencil"></i></button>`:''}
          ${minha?`<button class="chat-action-btn" title="Excluir" data-chat-action="excluir" data-msg-id="${escapeHtml(m.id)}"><i class="ti ti-trash" style="color:var(--red)"></i></button>`:''}
          <button class="chat-action-btn" title="Vincular a registro" data-chat-action="vincular" data-msg-id="${escapeHtml(m.id)}"><i class="ti ti-link"></i></button>
          <button class="chat-action-btn" title="Criar tarefa" data-chat-action="tarefa" data-msg-id="${escapeHtml(m.id)}"><i class="ti ti-checkbox"></i></button>
        </div>
      </div>
      ${minha?`<div class="chat-avatar mine">${escapeHtml((m.user||'?').charAt(0).toUpperCase())}</div>`:''}
    </div>`;
  });
  el.innerHTML=html;
  el.scrollTop=el.scrollHeight;
}

function _renderChatInfo(){
  const el=document.getElementById('chat-info-content');if(!el)return;
  if(_chatCanal.startsWith('dm:')){el.innerHTML='<div style="color:var(--muted);font-size:12px">Conversa direta</div>';return;}
  const ch=CHAT_CANAIS_CFG.find(c=>c.id===_chatCanal)||{nome:_chatCanal,desc:''};
  const msgs=(CACHE.chat_mensagens||[]).filter(m=>m.canal===_chatCanal&&!m.excluido);
  el.innerHTML=`<div style="font-weight:700;margin-bottom:4px"># ${escapeHtml(ch.nome)}</div>
    <div style="color:var(--muted);margin-bottom:12px">${escapeHtml(ch.desc||'')}</div>
    <div style="color:var(--muted)">Total de mensagens: <strong style="color:var(--text)">${msgs.length}</strong></div>
    <div style="color:var(--muted);margin-top:4px">Demandas abertas: <strong style="color:var(--text)">${msgs.filter(m=>m.tipo==='demanda'&&m.status==='aberta').length}</strong></div>`;
}

function _chatToggleInfo(){
  _chatInfoOpen=!_chatInfoOpen;
  const p=document.getElementById('chat-info-panel');if(p)p.style.display=_chatInfoOpen?'':'none';
  if(_chatInfoOpen)_renderChatInfo();
}

function chatInputKey(ev){if(ev.key==='Enter'&&!ev.shiftKey){ev.preventDefault();sendChatMessage();}}
function autoResizeChatInput(el){el.style.height='auto';el.style.height=Math.min(el.scrollHeight,120)+'px';}

function _chatToggleDemanda(){
  _chatEnviarComoDemanda=!_chatEnviarComoDemanda;
  const sel=document.getElementById('chat-demanda-area');
  const badge=document.getElementById('chat-tipo-badge');
  const btn=document.getElementById('chat-demanda-toggle-btn');
  if(sel)sel.style.display=_chatEnviarComoDemanda?'':'none';
  if(badge)badge.style.display=_chatEnviarComoDemanda?'inline':'none';
  if(btn)btn.style.background=_chatEnviarComoDemanda?'color-mix(in srgb,var(--warn) 15%,var(--surface))':'';
}

function _chatResponder(id){
  const m=(CACHE.chat_mensagens||[]).find(x=>x.id===id);if(!m)return;
  _chatReplyTo=id;
  const bar=document.getElementById('chat-reply-bar');
  const label=document.getElementById('chat-reply-label');
  if(bar)bar.style.display='flex';
  if(label)label.innerHTML=`<i class="ti ti-arrow-back-up" style="margin-right:4px"></i>Respondendo a <strong>${escapeHtml(m.user||'?')}</strong>: ${escapeHtml((m.texto||'').slice(0,50))}${(m.texto||'').length>50?'…':''}`;
  document.getElementById('chat-input')?.focus();
}
function _cancelarReply(){_chatReplyTo=null;const b=document.getElementById('chat-reply-bar');if(b)b.style.display='none';}

function _cancelarVinculo(){_chatVinculo=null;const b=document.getElementById('chat-vinculo-bar');if(b)b.style.display='none';}

function _chatEditar(id){
  const m=(CACHE.chat_mensagens||[]).find(x=>x.id===id);if(!m)return;
  _chatEditandoId=id;
  const inp=document.getElementById('chat-input');
  if(inp){inp.value=m.texto||'';autoResizeChatInput(inp);inp.focus();}
  document.getElementById('chat-destino-label').textContent='Editando mensagem…';
}

async function _chatExcluir(id){
  if(!await uiConfirm({tone:'danger',eyebrow:'Comunicação interna',title:'Excluir esta mensagem?',impact:'A mensagem deixará de aparecer na conversa.',confirmLabel:'Excluir mensagem'}))return;
  const lista=[...(CACHE.chat_mensagens||[])];
  const ix=lista.findIndex(m=>m.id===id);if(ix<0)return;
  lista[ix]={...lista[ix],excluido:true,excluidoEm:new Date().toISOString()};
  await DB.set('chat_mensagens',lista);
  _renderChatMessages();_renderChatSidebar();toast('Mensagem excluída');
}

async function sendChatMessage(){
  const inp=document.getElementById('chat-input');
  const texto=(inp?.value||'').trim();if(!texto)return;
  const u=window.SaaS?.currentUser?.()||{};
  const nomeUser=document.getElementById('tb-user')?.textContent||u.nome||'Usuário';
  // Editing existing message
  if(_chatEditandoId){
    const lista=[...(CACHE.chat_mensagens||[])];
    const ix=lista.findIndex(m=>m.id===_chatEditandoId);
    if(ix>=0){lista[ix]={...lista[ix],texto,editado:true,editadoEm:new Date().toISOString()};await DB.set('chat_mensagens',lista);}
    inp.value='';autoResizeChatInput(inp);_chatEditandoId=null;
    document.getElementById('chat-destino-label').textContent=document.getElementById('chat-canal-nome').textContent;
    _renderChatMessages();return;
  }
  const isDemanda=_chatEnviarComoDemanda;
  const areaDemanda=isDemanda?(document.getElementById('chat-demanda-area')?.value||_chatCanal):'';
  const isDM=_chatCanal.startsWith('dm:');
  const msg={
    id:Date.now().toString(36)+Math.random().toString(36).slice(2,7),
    canal:_chatCanal,
    texto,
    user:nomeUser,
    userEmail:u.email||'',
    ts:new Date().toISOString(),
    tipo:isDemanda?'demanda':'msg',
    dm:isDM||undefined,
    ...(isDemanda?{area:areaDemanda,status:'aberta'}:{}),
    ...(_chatReplyTo?{replyTo:_chatReplyTo}:{}),
    ...(_chatVinculo?{vinculo:_chatVinculo}:{}),
  };
  const lista=[...(CACHE.chat_mensagens||[]),msg];
  await DB.set('chat_mensagens',lista);
  inp.value='';autoResizeChatInput(inp);
  _cancelarReply();_cancelarVinculo();
  if(isDemanda)_chatToggleDemanda();
  _renderChatSidebar();_renderChatMessages();
}

async function assumirDemanda(id){
  const lista=[...(CACHE.chat_mensagens||[])];
  const ix=lista.findIndex(m=>m.id===id);if(ix<0)return;
  const u=window.SaaS?.currentUser?.()||{};
  lista[ix]={...lista[ix],status:'assumida',assumidaPor:document.getElementById('tb-user')?.textContent||u.nome||'Usuário',assumidaEm:new Date().toISOString()};
  await DB.set('chat_mensagens',lista);
  _renderChatSidebar();_renderChatMessages();toast('Demanda assumida ✓');
}

async function resolverDemanda(id){
  const lista=[...(CACHE.chat_mensagens||[])];
  const ix=lista.findIndex(m=>m.id===id);if(ix<0)return;
  const u=window.SaaS?.currentUser?.()||{};
  lista[ix]={...lista[ix],status:'resolvida',resolvidaPor:document.getElementById('tb-user')?.textContent||u.nome||'Usuário',resolvidaEm:new Date().toISOString()};
  await DB.set('chat_mensagens',lista);
  _renderChatSidebar();_renderChatMessages();toast('Demanda resolvida ✓');
}

// — Vínculo com registro —
let _chatVinculoParaMsgId=null;
function _abrirVinculoChat(){_chatVinculoParaMsgId=null;_chatVinculoFiltrar();openModal('modal-chat-vinculo');}
function _abrirVinculoMensagem(msgId){_chatVinculoParaMsgId=msgId;_chatVinculoFiltrar();openModal('modal-chat-vinculo');}

function _chatVinculoFiltrar(){
  const tipo=document.getElementById('cv-tipo')?.value||'pedido';
  const q=(document.getElementById('cv-busca')?.value||'').toLowerCase();
  let items=[];
  if(tipo==='pedido'){
    items=(CACHE.pedidos||DB.get('pedidos')||[]).filter(p=>!q||String(p.num||'').includes(q)||String(p.cliente||'').toLowerCase().includes(q)).slice(0,30).map(p=>({id:p.id,label:`#${p.num} — ${p.cliente||'?'}`,tipo:'pedido'}));
  } else if(tipo==='orcamento'){
    items=(CACHE.orcamentos||DB.get('orcamentos')||[]).filter(p=>!q||String(p.num||'').includes(q)||String(p.cliente||'').toLowerCase().includes(q)).slice(0,30).map(p=>({id:p.id,label:`ORC-${p.num} — ${p.cliente||'?'}`,tipo:'orcamento'}));
  } else if(tipo==='cliente'){
    items=(CACHE.clientes||DB.get('clientes')||[]).filter(c=>!q||String(c.nome||c.razao||'').toLowerCase().includes(q)).slice(0,30).map(c=>({id:c.id,label:c.nome||c.razao||'Cliente',tipo:'cliente'}));
  } else if(tipo==='os'){
    items=(CACHE.os||DB.get('os')||[]).filter(o=>!q||String(o.num||'').includes(q)||String(o.pedidoNum||'').includes(q)).slice(0,30).map(o=>({id:o.id,label:`OS-${o.num||'?'} ${o.pedidoNum?`(Ped. ${o.pedidoNum})`:''}`,tipo:'os'}));
  }
  const el=document.getElementById('cv-lista');if(!el)return;
  if(!items.length){el.innerHTML='<div style="padding:12px;color:var(--muted);font-size:12px;text-align:center">Nenhum resultado</div>';return;}
  el.innerHTML=items.map(it=>`<button onclick="_selecionarVinculo('${it.tipo}','${it.id}','${escapeHtml(it.label).replace(/'/g,"\\'")}',this)" style="display:block;width:100%;padding:8px 12px;border:none;border-bottom:1px solid var(--border);background:var(--surface);color:var(--text);text-align:left;cursor:pointer;font-size:12px" onmouseenter="this.style.background='var(--surface2)'" onmouseleave="this.style.background='var(--surface)'">${escapeHtml(it.label)}</button>`).join('');
}

async function _selecionarVinculo(tipo,id,label){
  const vinculo={tipo,id,label};
  const msgId=_chatVinculoParaMsgId;
  closeModal('modal-chat-vinculo');
  if(msgId){
    // Link to existing message
    const lista=[...(CACHE.chat_mensagens||[])];
    const ix=lista.findIndex(m=>m.id===msgId);
    if(ix>=0){lista[ix]={...lista[ix],vinculo};await DB.set('chat_mensagens',lista);}
    _renderChatMessages();toast('Vínculo adicionado ✓');
  } else {
    // Link to next message to be sent
    _chatVinculo=vinculo;
    const bar=document.getElementById('chat-vinculo-bar');
    const lbl=document.getElementById('chat-vinculo-text');
    if(bar)bar.style.display='flex';
    if(lbl)lbl.textContent=label;
    document.getElementById('chat-input')?.focus();
  }
}

function _abrirVinculoRegistro(tipo,id){
  if(!tipo||!id)return;
  if(tipo==='pedido')verDetalhe(id);
  else if(tipo==='cliente'){showPage('clientes');openClienteForm(id);}
  else if(tipo==='os')showPage('os');
}

// — Converter em tarefa —
function _chatInputParaTarefa(){
  const inp=document.getElementById('chat-input');
  const texto=(inp?.value||'').trim();
  if(!texto){toast('Escreva a tarefa no campo de mensagem antes de converter','warn');return;}
  _criarTarefaDoChat(texto);
  inp.value='';autoResizeChatInput(inp);
}

async function _chatMsgParaTarefa(msgId){
  const m=(CACHE.chat_mensagens||[]).find(x=>x.id===msgId);if(!m)return;
  await _criarTarefaDoChat(m.texto||'',msgId);
}

async function _criarTarefaDoChat(texto,msgId){
  const u=window.SaaS?.currentUser?.()||{};
  const id=Date.now().toString(36)+Math.random().toString(36).slice(2,6);
  const tarefa={id,titulo:texto.slice(0,80),descricao:texto,status:'todo',area:'geral',prioridade:'media',criador:u.email||'',criadoEm:new Date().toISOString(),origem:'chat',origemMsgId:msgId||null};
  const lista=[...(CACHE.rotinas||DB.get('rotinas')||[]),tarefa];
  await DB.set('rotinas',lista);CACHE.rotinas=lista;
  if(msgId){
    const msgs=[...(CACHE.chat_mensagens||[])];
    const ix=msgs.findIndex(m=>m.id===msgId);
    if(ix>=0){msgs[ix]={...msgs[ix],tarefaId:id};await DB.set('chat_mensagens',msgs);}
    _renderChatMessages();
  }
  toast('Tarefa criada em Rotinas & Atividades ✓','success');
}

// — DM —
function _abrirNovoDM(){_renderDMOptions();openModal('modal-chat-dm');}
function _renderDMOptions(){
  const q=(document.getElementById('dm-busca')?.value||'').toLowerCase();
  const equipe=(CACHE.pessoas||[]).filter(p=>p.ativo!==false&&(!q||String(p.nome||'').toLowerCase().includes(q)));
  const el=document.getElementById('dm-lista');if(!el)return;
  if(!equipe.length){el.innerHTML='<div style="padding:12px;color:var(--muted);font-size:12px;text-align:center">Nenhum membro encontrado</div>';return;}
  const curEmail=(window.SaaS?.currentUser?.()||{}).email||'';
  el.innerHTML=equipe.filter(p=>p.email&&p.email!==curEmail).map(p=>`<button onclick="_iniciarDM('${escapeHtml(p.email||'')}',this)" style="display:flex;align-items:center;gap:10px;width:100%;padding:9px 12px;border:none;border-bottom:1px solid var(--border);background:var(--surface);color:var(--text);text-align:left;cursor:pointer" onmouseenter="this.style.background='var(--surface2)'" onmouseleave="this.style.background='var(--surface)'">
    <div style="width:30px;height:30px;border-radius:50%;background:var(--accent);display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700;color:#fff;flex-shrink:0">${escapeHtml((p.nome||'?').charAt(0).toUpperCase())}</div>
    <div><div style="font-weight:600;font-size:12px">${escapeHtml(p.nome||'?')}</div><div style="font-size:10px;color:var(--muted)">${escapeHtml(p.cargo||p.area||'')}</div></div>
  </button>`).join('');
}

function _iniciarDM(emailOutro){
  const curEmail=(window.SaaS?.currentUser?.()||{}).email||'anonimo';
  const canal='dm:'+[curEmail,emailOutro].sort().join(':');
  closeModal('modal-chat-dm');
  _selecionarCanalChat(canal);
  _renderChatDMs();
}
